import { useI18n } from '@i18n/I18nProvider'
import type { ReactNode } from 'react'
import { Link } from 'wouter'
import { Icon } from './Icon'

// Contenedor de pantalla: título, vuelta atrás opcional y margen para la barra inferior.
export const Screen = ({ title, backHref, children }: { title?: string; backHref?: string; children: ReactNode }) => {
	const { t } = useI18n()
	return (
		<main className="mx-auto w-full max-w-xl px-4 pt-4 pb-28">
			{backHref && (
				<Link
					href={backHref}
					className="mb-2 inline-flex min-h-12 items-center gap-1 font-semibold text-forest-800"
				>
					<Icon name="back" className="size-5" />
					{t('common.back')}
				</Link>
			)}
			{title && <h1 className="mb-4 text-3xl leading-tight">{title}</h1>}
			{children}
		</main>
	)
}
